/**
 * Development-only logging.
 *
 * This used to log unconditionally, and custom.fetch.func.ts fed it
 * `options.body` for every POST — including auth/login, so plaintext
 * passwords ended up in server logs and browser consoles. Gate on the
 * environment, and never pass request bodies.
 */
const isDev = process.env.NODE_ENV !== 'production'

export const log = (msg: unknown) => {
  if (!isDev) return
  console.log(msg)
}
